import { Table } from 'components/table-compat/table-compat'
import { Container } from 'components/container/Container'
import { buildDataTableObject } from 'utils/data'
import {
    addHyperLinkToFirstColumn,
    getDynamicSubPath,
    setFirstColumnInHeaders,
} from './helpers'
import { useSafetyTotal } from 'hooks/safety/useSafetyTotal'
import { BasicPlaceholder } from 'components/placeholder'
import useRefresh from 'hooks/utils/useRefresh'
import useCountdown from 'hooks/utils/useCountdown'
import { ErrorAlert } from 'components/error-fallback/error-alert'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useEssentials } from 'hooks/utils/useEssentials'
import { translateTableData } from 'locales/utils'

export const SafetyTotal = () => {
    const { t, currentLocation, pathname, env, logout, session, isEnglish } =
        useEssentials()
    const { safety } = TRANSLATION_KEYS
    const { nonStoreLabel, total } = safety
    const { title } = total

    const dynamicSubPath = getDynamicSubPath(currentLocation)
    let { data, isLoading, isError, refetch, remove, error } = useSafetyTotal({
        env,
        accessToken: session?.accessToken ?? '',
        location: currentLocation,
        dynamicSubPath,
    })
    useRefresh(refetch, remove)
    const count = useCountdown(5, logout, error as Error)

    if (isLoading) {
        return (
            <div className="placeholder-container" data-testid="placeholder">
                <BasicPlaceholder type="table" rows={5} columns={5} />
            </div>
        )
    }

    if (isError || !data) {
        return (
            <ErrorAlert error={error} count={count} onRetry={() => refetch()} />
        )
    }

    data = {
        ...data,
        headings: setFirstColumnInHeaders(data, 'Location'),
    }
    data = addHyperLinkToFirstColumn(data, pathname)
    data = translateTableData({
        t,
        table: data,
        translation: total,
    })

    return (
        <Container className="hc8-pa-4x">
            <p>{t(nonStoreLabel)}</p>
            <Table
                data={buildDataTableObject({
                    currentData: data,
                    widths: isEnglish ? [70, 90, 90, 110] : [75, 180, 200, 180],
                    pinFirstColumn: true,
                })}
                name={t(title)}
                scrollableWidth={true}
            />
        </Container>
    )
}
